import firebase from '@/firebase'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

const ui = new firebaseui.auth.AuthUI(firebase.auth());


export { firebaseui, ui }
